/*
 * Fetchers.
 */

import {ApiAccountRuleAdoption} from '../../models/api/accountRuleAdoptionModel';
import {fetchApiAsync} from '../../services/http/http';
import {useSettingsQuery, UseSettingsQueryOptions} from '../helpers/useSettingsQuery';

export function useFetchHasPotentialAccountRules(namespace: string, options?: UseSettingsQueryOptions) {
  const {data, asyncStatus} = useSettingsQuery(
    [`rule_accounts_adoption_${namespace}`],
    async ({company, cancelToken}) =>
      fetchApiAsync(ApiAccountRuleAdoption, `${company.url}/namespaces/${namespace}/rules/account_adoption`, {
        cancelToken,
      }),
    options,
  );

  return {hasPotentialAccountRules: data?.hasPotentialAccountRules || false, status: asyncStatus};
}
